import React, { useState } from "react";
import * as Fa from "react-icons/fa";
import { Dropdown } from "primereact/dropdown";
import { Checkbox } from "primereact/checkbox";
// import XLSX from "xlsx";
import { toast } from "react-toastify";
import storage from "../../../Services/Storage";
import {
    createAPIEndpoint,
    Endpoint,
} from "../../../Services/stockreport/StockReport";
// import Loader from "../../../Components/Loader";
import { downloadExcel } from "../../../Services/GlobalFunc/downloadExcel";
import { GetDateFormat } from "../../../Services/GlobalFunc/DateFormat";
const generateDateArray = () => {
    const result = [];
    const day = new Date();
    const startDate = new Date(2023, 0);
    const endDate = new Date(day.getFullYear(), day.getMonth());
    let currentDate = startDate;
    while (currentDate <= endDate) {
        const month = currentDate.getMonth();
        const year = currentDate.getFullYear();
        const monthNames = [
            "JAN",
            "FEB",
            "MAR",
            "APR",
            "MAY",
            "JUN",
            "JUL",
            "AUG",
            "SEP",
            "OCT",
            "NOV",
            "DEC",
        ];
        const monthDesc = monthNames[month];

        const formattedDate = `${year}${String(month + 1).padStart(2, "0")}`;

        result.push({
            DATEDESC: `${monthDesc} ${year}`,
            DATE: formattedDate,
        });

        currentDate.setMonth(currentDate.getMonth() + 1);
    }

    return result;
};
let divisonOpions = generateDateArray();

const StockMonthlyDetailReport = () => {
    // const currentDate = format(new Date(), "yyyy-MM-dd");
    //   const date = subDays(new Date(), 7);
    // const sevenDays = format(date, "yyyy-MM-dd");
    const [fromDate, setFromDate] = useState(
        divisonOpions[divisonOpions.length - 3]
    );
    const [toDate, setToDate] = useState(divisonOpions[divisonOpions.length - 1]);
    const [loadingExcel, setLoadingExcel] = useState(false);
    const auth = storage.getLocal("user");
    const fileTypes = [
        { label: "CSV", value: "csv" },
        { label: "XLSX", value: "xlsx" },
    ];
    const [fileType, setFileType] = useState("csv");

    const handleExportExcel = () => {
        if (fileType == null) {
            toast.warning("Please select file type", {
                position: toast.POSITION.TOP_CENTER,
                pauseOnFocusLoss: false,
                closeButton: false,
                autoClose: 2000,
            });
            return;
        }
        setLoadingExcel(true);
        let uniqueNo = `StockMonthlyDetailRpt${GetDateFormat()}`;
        let chkpck = selectedCategories?.filter((item) => {
            return item.key == "P";
        });
        let chkltr = selectedCategories?.filter((item) => {
            return item.key == "L";
        });
        createAPIEndpoint()
            .get(
                `${Endpoint.StockMonthlyDetailRpt}?CompId=${auth.CompId}&userId=${
                    auth.UserId
                }&Todatestring=${toDate.DATE}&FromDatestring=${fromDate.DATE}&chkpack=${
                    chkpck.length? "Y" : "N"
                }&chkltr=${chkltr.length ? "Y" : "N"}`
            )
            .then((val) => {
                if (val.data.length > 0) {
                    if (fileType === "xlsx") {
                        downloadExcel(val.data, `${uniqueNo}.xlsx`);
                    } else if (fileType === "csv") {
                        downloadExcel(val.data, `${uniqueNo}.csv`);
                    }
                } else {
                    toast.warning("No data found between these dates", {
                        position: toast.POSITION.TOP_CENTER,
                        pauseOnFocusLoss: false,
                        closeButton: false,
                        autoClose: 2000,
                    });
                }
                setLoadingExcel(false);
            })
            .catch((err) => {
                toast.error(`${err.response.data}`, {
                    position: toast.POSITION.TOP_CENTER,
                    pauseOnFocusLoss: false,
                    closeButton: false,
                    autoClose: 2000,
                });
                setLoadingExcel(false);
            });
    };

    const categories = [
        { name: "Pack", key: "P" },
        { name: "Ltr", key: "L" },
    ];
    const [selectedCategories, setSelectedCategories] = useState([]);

    const onCategoryChange = (e) => {
        let _selectedCategories = [...selectedCategories];

        if (e.checked) _selectedCategories.push(e.value);
        else
            _selectedCategories = _selectedCategories.filter(
                (category) => category.key !== e.value.key
            );

        setSelectedCategories(_selectedCategories);
    };

    return (
        <>
            <div className="col-12 pt-0 pb-4">
                <div className="row">
                    <div className="col-lg-6 col-md-6 col-sm-12">
                        <h3 className="py-2">Stock Monthly Detail Report</h3>
                    </div>
                    <div className="col-lg-6 col-md-6 col-sm-12">
                        <div className="float-end mb-2">
                            <button
                                type="button"
                                className="btn btn-primary"
                                disabled={loadingExcel}
                                onClick={handleExportExcel}
                            >
                                {loadingExcel ? "Loading..." : "Export"}{" "}
                                {loadingExcel ? (
                                    <span
                                        className="spinner-border spinner-border-sm"
                                        role="status"
                                        aria-hidden="true"
                                    ></span>
                                ) : (
                                    <Fa.FaDownload className="ms-2" />
                                )}
                            </button>
                        </div>
                    </div>
                </div>

                <section className="sales-box">
                    <form>
                        <div className="row">
                            <div className="col-lg-3 col-md-3 col-sm-12">
                                <label className="form-label">From Date</label>
                                <Dropdown
                                    value={fromDate}
                                    onChange={(e) => setFromDate(e.value)}
                                    options={divisonOpions}
                                    optionLabel="DATEDESC"
                                />
                            </div>
                            <div className="col-lg-3 col-md-3 col-sm-12">
                                <label className="form-label">To Date</label>
                                <Dropdown
                                    value={toDate}
                                    onChange={(e) => setToDate(e.value)}
                                    options={divisonOpions}
                                    optionLabel="DATEDESC"
                                />
                            </div>
                            <div className="col-lg-3 col-md-3 col-sm-12">
                                <label className="form-label mb-2">File Type</label>
                                <Dropdown
                                    value={fileType}
                                    options={fileTypes}
                                    onChange={(e) => setFileType(e.value)}
                                    optionLabel="label"
                                    placeholder="Select a file type"
                                />
                            </div>
                            <div className="col-lg-3 col-md-3 col-sm-12 pt-3">
                                <div className="mt-4">
                                    {categories.map((category) => {
                                        return (
                                            <div key={category.key} className="d-inline-flex">
                                                <Checkbox
                                                    inputId={category.key}
                                                    name="category"
                                                    value={category}
                                                    onChange={onCategoryChange}
                                                    checked={selectedCategories.some(
                                                        (item) => item.key === category.key
                                                    )}
                                                />
                                                <label htmlFor={category.key} className="me-2">
                                                    {category.name}
                                                </label>
                                            </div>
                                        );
                                    })}
                                </div>
                            </div>
                            {/* <div className="col-lg-2 col-md-2 col-sm-12">
                            <div className="float-end mt-4">
                               
                                <button
                                    type="button"
                                    className="btn btn-primary"
                                    onClick={()=>{handleExportExcel(fromDate,toDate);}}
                                    disabled={loadingExcel}
                                >
                                    {loadingExcel ? "Loading..." : "Export"}{" "}
                                    {loadingExcel ? (
                                        <span
                                            className="spinner-border spinner-border-sm"
                                            role="status"
                                            aria-hidden="true"
                                        ></span>
                                    ) : (
                                        <Fa.FaFileExport className="ms-2" />
                                    )}
                                </button>
                            </div>
                        </div> */}
                        </div>
                    </form>
                </section>
            </div>
        </>
    );
};

export default StockMonthlyDetailReport;
